import styled from 'styled-components';

export const ContentWrapper = styled.div`
  padding: 0 40px;
  color: ${(props) => props.theme['color.text.light']};
`;

export const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
`;

